import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import "./index.css";
import { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import ProfileImg from "../../assets/image/avatar.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import CancelIcon from "@mui/icons-material/Cancel";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomSelect from "../../component/custom-select";
import useDebounce from "./useDebounce";
import { getAllInactiveUser, getUsersAPI, removeUserAPI, userActivityAPI } from "../../api/auth";
import CustomInput from "../../component/custom-input";

// const rows = [
//   createData(
//     "202403063433",
//     <Stack direction="row" alignItems="center" spacing={3}>
//       <img src={ProfileImg} />
//       <p>Chirag jain</p>
//     </Stack>,
//     6464646464,
//     <Box className="activeBox active">
//       <Box className="innerIcon">
//         <CheckCircleOutlineIcon style={{ color: "#fff", fontSize: "21px" }} />
//       </Box>
//       <Typography>Active</Typography>
//     </Box>,
//     <Box
//       sx={{
//         position: "relative",
//       }}
//     >
//       <div className="center">
//         <input type="checkbox" />
//       </div>
//     </Box>,
//     <Box>
//       <Stack direction="row" alignItems="center" spacing={1}>
//         <Link className="btnLink" style={{ background: "#CFFFE2" }}>
//           <EditIcon style={{ color: "#00BE4C" }} />
//         </Link>
//         <Link className="btnLink" style={{ background: "#FFDCDC" }}>
//           <DeleteIcon style={{ color: "#FF0000" }} />
//         </Link>
//       </Stack>
//     </Box>
//   ),
//   createData(
//     "202403063433",
//     <Stack direction="row" alignItems="center" spacing={3}>
//       <img src={ProfileImg} />
//       <p>Chirag jain</p>
//     </Stack>,
//     6464646464,
//     <Box className="activeBox active">
//       <Box className="innerIcon">
//         <CheckCircleOutlineIcon style={{ color: "#fff", fontSize: "21px" }} />
//       </Box>
//       <Typography>Active</Typography>
//     </Box>,
//     <Box
//       sx={{
//         position: "relative",
//       }}
//     >
//       <div className="center">
//         <input type="checkbox" />
//       </div>
//     </Box>,
//     <Box>
//       <Stack direction="row" alignItems="center" spacing={1}>
//         <Link className="btnLink" style={{ background: "#CFFFE2" }}>
//           <EditIcon style={{ color: "#00BE4C" }} />
//         </Link>
//         <Link className="btnLink" style={{ background: "#FFDCDC" }}>
//           <DeleteIcon style={{ color: "#FF0000" }} />
//         </Link>
//       </Stack>
//     </Box>
//   ),
// ];

function ManageUser() {
  const [users, setUsers] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [occupationSearch, setOccupationSearch] = useState("");
  const [maritalStatusSearch, setMaritalStatusSearch] = useState("");
  const [sortOption, setSortOption] = useState("Newest");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [open, setOpen] = useState(false);
  const [mopen, setMopen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isActiveFilter, setIsActiveFilter] = useState(true);

  const debouncedSearchInput = useDebounce(searchInput, 500);
  const debouncedCitySearch = useDebounce(citySearch, 500);
  const debouncedOccupationSearch = useDebounce(occupationSearch, 500);
  const debouncedMaritalStatusSearch = useDebounce(maritalStatusSearch, 500);

  const sortOrder = sortOption === "Newest" ? "desc" : "asc";

  const [loading, setLoading] = useState(false);

  const query = {
    page: page,
    limit: 10,
    fullName: searchInput,
    city: citySearch,
    occupation: occupationSearch,
    maritalStatus: maritalStatusSearch,
    sort: sortOption,
  };
  const handleUsers = async () => {

    const res = await getUsersAPI(query)
    if (res.remote === "success") {
      setUsers(res.data?.users || []);
      setTotalPages(Math.ceil(res.data.totalUsers / 10));
    } else {
      console.log("API Error:", res);
    }
    console.log(res, 'nj')
  };

  const getUserActivity = async () => {
    const resp = await getAllInactiveUser(query)
    if (resp.remote === "success") {
      setUsers(resp.data?.users || []);
      setTotalPages(Math.ceil(resp.data.totalUsers / 10));
    } console.log(resp)
  }

  useEffect(() => {
    if (isActiveFilter) {
      handleUsers();
    } else {
      getUserActivity();
    }
  }, [
    page,
    debouncedSearchInput,
    debouncedCitySearch,
    debouncedOccupationSearch,
    debouncedMaritalStatusSearch,
    sortOption,
    isActiveFilter,
  ]);
  console.log(page, 'isnc')
  console.log(totalPages, 'isncssssss')

  const handleUserActivity = async (id) => {
    setLoading(true);

    const response = await userActivityAPI({ id });
    if (response.remote === "success") {
      if (
        response.data.message === "Inactive" ||
        response.data.message === "Active"
      ) {
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user._id === id
              ? {
                ...user,
                isActive: response.data.message === "Active" ? true : false,
              }
              : user
          )
        );
      } else {
        console.log("Error toggling verification status:", response.message);
      }
    } else {
      console.log("Error activity user:", response);
    }
    setLoading(false);
  };


  const SortBy = [
    { value: "Newest", label: "Newest" },
    { value: "Oldest", label: "Oldest" },
  ];

  const handleSortChange = (event) => {
    setSortOption(event.target.value);
  };

  const increasePage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const decreasePage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleClickOpen = (id) => {
    setSelectedUserId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirmDelete = async (id) => {
    setLoading(true);

    const response = await removeUserAPI({ id });

    const { message } = response.data;
    if (
      response.remote === "success" &&
      message === "User deleted temporarily"
    ) {
      setUsers((prevUsers) => prevUsers.filter((user) => user._id !== id));
    } else {
      console.log("API Error:", response);
    }
    setOpen(false);
    setLoading(false);
  };
  return (
    <Box>
      <Box sx={{ margin: "10px 0" }}>
        <Typography variant="h4" sx={{ fontSize: "30px", fontWeight: "500" }}>
          Manage User
        </Typography>
      </Box>
      <Box className="FormBox" mb={3}>
        <Grid container spacing={2} mb={2}>
          <Grid item lg={6}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography>Sort by</Typography>
              <CustomSelect
                name="sortBy"
                options={SortBy}
                value={sortOption}
                onChange={handleSortChange}
              />
            </Stack>
          </Grid>
          <Grid item lg={6}>
            <Stack direction="row" spacing={2} mb={2}>

              <Button variant="contained"
                sx={{
                  background: isActiveFilter ? "#1ACC43" : "#a5d6a7",
                  "&:hover": {
                    backgroundColor: "#1ACC43",
                  },
                }}
                onClick={() => {
                  setIsActiveFilter(true);
                  setPage(1);
                }}              >
                Active
              </Button>
              <Button variant="contained"
                sx={{
                  background: !isActiveFilter ? "#cc1a31" : "#ef9a9a",
                  "&:hover": {
                    backgroundColor: "#cc1a31",
                  },
                }}
                onClick={() => {
                  setIsActiveFilter(false);
                  setPage(1);
                }}
              >
                Inactive
              </Button>
            </Stack>

          </Grid>

          <Grid item lg={6}>
            <CustomInput
              inputType="Text"
              label="Search by Occupation"
              placeholder="Search by occupation"
              value={occupationSearch}
              onChange={(e) => setOccupationSearch(e.target.value)}
            ></CustomInput>
          </Grid>

          <Grid item lg={6}>
            <CustomInput
              inputType="Text"
              label="Search by Marital Status"
              placeholder="Search by Marital Status"
              value={maritalStatusSearch}
              onChange={(e) => setMaritalStatusSearch(e.target.value)}
            ></CustomInput>
          </Grid>

          <Grid item lg={6}>
            <CustomInput
              inputType="text"
              label="Search by City"
              placeholder="Search by city"
              value={citySearch}
              onChange={(e) => setCitySearch(e.target.value)}
            ></CustomInput>
          </Grid>

          <Grid item lg={6}>
            <CustomInput
              inputType="text"
              label="Search by Name"
              placeholder="Search by name"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            ></CustomInput>
          </Grid>
        </Grid>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Member ID</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Phone number</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Occupation</TableCell>
                <TableCell>Active/Inactive</TableCell>
                <TableCell>Disable/Enable</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users && users.length > 0 ? (
                users.map((user) => (
                  <TableRow
                    key={user._id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {user.memberId}
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={3}>
                        <Avatar
                          src={process.env.REACT_APP_BASE_URL + "/uploads/" + user.userDetails.profileImage}
                          sx={{ width: 50, height: 50, cursor: 'pointer' }}
                          onClick={() => setMopen(true)}
                        />
                        {/* <Modal open={mopen} onClose={() => setMopen(false)}>
                          <Box
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              outline: 'none',
                            }}
                          >
                            <img
                              src={process.env.REACT_APP_BASE_URL + "/uploads/" + user.userDetails.profileImage}
                              alt="Enlarged"
                              style={{ width: 300, height: 300, borderRadius: '50%' }}
                            />
                          </Box>
                        </Modal> */}

                        <p>{user.fullName}</p>
                      </Stack>
                    </TableCell>
                    <TableCell>{user.phoneNumber}</TableCell>
                    <TableCell>{user.city}</TableCell>
                    <TableCell>{user.userDetails.occupation}</TableCell>
                    <TableCell>
                      <Box
                        className="activeBox"
                        style={
                          user.isActive === false
                            ? { background: "#FFDCDC" }
                            : { background: "#cfffe2" }
                        }
                      >
                        {user.isActive === true ? (
                          <Box className="innerIcon">
                            <CheckCircleOutlineIcon
                              style={{ color: "#fff", fontSize: "21px" }}
                            />
                          </Box>
                        ) : (
                          <Box
                            className="innerIcon"
                            style={{ background: "#ffa9a9" }}
                          >
                            <CancelOutlinedIcon
                              style={{ color: "#ff0000", fontSize: "21px" }}
                            />
                          </Box>
                        )}
                        {/* <Box className="innerIcon">
                          <CheckCircleOutlineIcon
                            style={{ color: "#fff", fontSize: "21px" }}
                          />
                        </Box> */}
                        <Typography>
                          {user.isActive === true ? "Active" : "Inactive"}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          position: "relative",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={user.isActive === false}
                          onChange={() => handleUserActivity(user._id)}
                          disabled={loading}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Link
                          to={`/user-edit/${user._id}`}
                          className="btnLink"
                          style={{ background: "#CFFFE2" }}
                        >
                          <EditIcon style={{ color: "#00BE4C" }} />
                        </Link>
                        <Link
                          className="btnLink"
                          style={{ background: "#FFDCDC" }}
                          onClick={() => handleClickOpen(user._id)}
                        >
                          <DeleteIcon style={{ color: "#FF0000" }} />
                        </Link>
                        <Dialog open={open} onClose={handleClose}>
                          <DialogContent>
                            <Typography
                              style={{
                                fontWeight: 500,
                                fontSize: "18.51px",
                                lineHeight: "20.36px",
                              }}
                            >
                              Do you really want to remove the user?
                            </Typography>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose} color="primary">
                              Cancel
                            </Button>
                            <Button
                              onClick={() =>
                                handleConfirmDelete(selectedUserId)
                              }
                              color="error"
                            >
                              Remove
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <p>No users found</p>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 2,
        }}
      >
        <button onClick={decreasePage} disabled={page === 1}>
          -
        </button>
        <span>
          Page {page}/{totalPages}
        </span>
        <button onClick={increasePage} disabled={page === totalPages}>
          +
        </button>
      </Box>
    </Box >
  );
}

export default ManageUser;
